import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const ControllerIcon = ({ size, color, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, color: color, deg: deg },
    React.createElement("path", { fill: "#B8BECC", fillRule: "evenodd", d: "M10 8l4 4H6z" })));
export const Controller = iconGenerator(ControllerIcon);
//# sourceMappingURL=Controller.js.map